<div class="linked-issue">
  @if (showKey()) {
    <a
      class="linked-issue__key"
      [href]="browseUrl()"
      target="_blank"
      rel="noopener noreferrer"
      [attr.aria-label]="'linkedIssue.openAria' | translate: { key: issueKey() }"
    >
      <span class="linked-issue__key-text">{{ issueKey() }}</span>
      <mat-icon class="linked-issue__key-icon" aria-hidden="true">arrow_outward</mat-icon>
    </a>

    @if (summary()) {
      <span class="linked-issue__summary">{{ summary() }}</span>
    }
  }

  @if (status(); as s) {
    <span [class]="'linked-issue__status linked-issue__status--' + statusClass()">
      <span class="linked-issue__status-dot"></span>
      {{ s.name }}
    </span>
  } @else if (loading()) {
    <mat-progress-spinner class="linked-issue__spinner" diameter="16" mode="indeterminate"></mat-progress-spinner>
  } @else {
    <button type="button" class="linked-issue__load" (click)="loadStatus()">
      <mat-icon class="linked-issue__load-icon" aria-hidden="true">refresh</mat-icon>
      {{ 'linkedIssue.loadStatus' | translate }}
    </button>
  }

  @if (errorKey()) {
    <span class="linked-issue__error">
      {{ errorKey()! | translate: trackerError()?.params }}
      @if (trackerError()?.accountLink) {
        <a data-testid="tracker-error-account" routerLink="/account">{{ trackerErrorKeys.toAccount | translate }}</a>
      }
    </span>
  }
</div>
